import Axios from 'core/axios';
import Rest from 'core/rest';
import Validation from 'core/validation';
import { getLocale } from 'core/i18n';
import Tools from 'core/tools';

import {
  openMask,
  closeMask,
  openError,
	postSession
} from '../mainModule/action';

export const LOGIN_POST_ERROR = 'LOGIN_POST_ERROR';
export const LOGIN_CLEAR_ERROR = 'LOGIN_CLEAR_ERROR';
export const OPEN_FORGOT_MIMA_DAILOG = 'OPEN_FORGOT_MIMA_DAILOG';
export const CLOSE_FORGOT_MIMA_DAILOG = 'CLOSE_FORGOT_MIMA_DAILOG';
export const OPEN_MIMA_SUCCESS_DAILOG = 'OPEN_MIMA_SUCCESS_DAILOG';
export const CLOSE_MIMA_SUCCESS_DAILOG = 'CLOSE_MIMA_SUCCESS_DAILOG';

export function login(data, props) {
  return (dispatch) => {
    // 清空所有錯誤
		dispatch({
			type: LOGIN_CLEAR_ERROR
    });
    
    // 欄位驗證
    const errors = Validation.validateLoginInfo(data);

    if (errors && JSON.stringify(errors) !== '{}') {
      // 驗證失敗，顯示錯誤
      return dispatch({
        type: LOGIN_POST_ERROR,
        errors
      });
    } else {
      // 驗證成功，打登入API
      return dispatch(postSession(data, props));
    }
  };
};



export function forgotMima(data) {
  return (dispatch) => {
    // 清空所有錯誤
		dispatch({
			type: LOGIN_CLEAR_ERROR
    });
    // 欄位驗證
    const errors = Validation.validateLoginInfo(data);
    if (errors && JSON.stringify(errors) !== '{}') {
      // 驗證失敗，顯示錯誤
      return dispatch({
        type: LOGIN_POST_ERROR,
        errors
      });
    } else {
      dispatch(closeForgotMimaDailog())
      // 驗證成功，打登入API
      let requestData = {
        agentName: data.forgetPW_skyAgentName,
        locale: getLocale()
      };
      dispatch(openMask());
      return Axios.post(Rest.session.postMima(), requestData)
				.then(() => {
			   	dispatch(closeMask());
					dispatch(openSuccesDailog());
				})
				.catch((error) => {
					dispatch(closeMask());
					return dispatch(openError(error));
				});
    }
  };
};

export function changeMima(data) {
  return (dispatch) => {
    // 清空所有錯誤
		dispatch({
			type: LOGIN_CLEAR_ERROR
    });

    // 欄位驗證
    const errors = Validation.validateForgot(data);
    if (errors && JSON.stringify(errors) !== '{}') {
      // 驗證失敗，顯示錯誤
      return dispatch({
        type: LOGIN_POST_ERROR,
        errors
      });
    } else {
      // 驗證成功，打登入API
      let requestData = { mima: data.mima };
      dispatch(openMask());
      return Axios.put(Rest.session.putMima(), requestData, {headers: { Authorization: data.token } })
				.then(() => {
			   	dispatch(closeMask());
					dispatch(openSuccesDailog());
				})
				.catch((error) => {
					dispatch(closeMask());
					return dispatch(openError(error));
				});
    }
  };
};

//開啟/關閉 忘記密碼dialog
export function openForgotMimaDailog() {
  return (dispatch) => {
    dispatch({
			type: LOGIN_CLEAR_ERROR
    });
		dispatch({
			type: OPEN_FORGOT_MIMA_DAILOG
    });
  };
};
export function closeForgotMimaDailog() {
  return (dispatch) => {
		dispatch({
			type: CLOSE_FORGOT_MIMA_DAILOG
    });
  };
};

//開啟/關閉 成功訊息dialog
export function openSuccesDailog() {
  return (dispatch) => {
		dispatch({
			type: OPEN_MIMA_SUCCESS_DAILOG
    });
  };
};
export function closeSuccesDailog(props) {
  return (dispatch) => {
		dispatch({
			type: CLOSE_MIMA_SUCCESS_DAILOG
    });
    sessionStorage.removeItem('user')
    // 導轉至登入頁
    let url = Tools.generateLocaleUrl(getLocale(), '/Login')
    if (props && props.history) props.history.push(url);
  };
};